import WalletConfig from '../components/WalletConfig';

const WalletConfigPage = () => {
	return <WalletConfig />;
};

export default WalletConfigPage;
